import { LegalLayout } from "@/pages/legal/LegalLayout";
import { deleteDataContent } from "@/legal/legalContent";

export default function DeleteDataPage() {
  return <LegalLayout content={deleteDataContent} testId="delete-data-page" />;
}
